module.exports = __webpack_public_path__ + "static/media/ANT.0debd73a.svg";